
export default [
    {
        COUNTRY: 'AT',
        ZONE: 'AT10',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT11',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT12',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT13',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT14',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT15',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT16',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT17',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT18',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT19',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT20',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT21',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT22',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT23',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT24',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT25',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT26',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT27',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT28',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT30',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT31',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT32',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT33',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT34',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT35',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT36',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT37',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT38',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT39',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT40',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT41',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT42',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT43',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT44',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT45',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT46',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT47',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT48',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT49',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT50',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT51',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT52',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT53',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT54',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT55',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT56',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT57',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT60',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT61',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT62',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT63',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT64',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT65',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT66',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT67',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT68',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT69',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT70',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT71',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT72',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT73',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT74',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT75',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT80',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT81',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT82',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT83',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT84',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT85',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT86',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT87',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT88',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT89',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT90',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT91',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT92',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT93',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT94',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT95',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT96',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT97',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT98',
    },
    {
        COUNTRY: 'AT',
        ZONE: 'AT99',
    },
    {
        COUNTRY: 'AL',
        ZONE: 'AL10',
    },
    {
        COUNTRY: 'AL',
        ZONE: 'AL20',
    },
    {
        COUNTRY: 'AL',
        ZONE: 'AL30',
    },
    {
        COUNTRY: 'AL',
        ZONE: 'AL45',
    },
    {
        COUNTRY: 'AL',
        ZONE: 'AL80',
    },
    {
        COUNTRY: 'AL',
        ZONE: 'AL84',
    },
    {
        COUNTRY: 'AL',
        ZONE: 'AL85',
    },
    {
        COUNTRY: 'AL',
        ZONE: 'AL90',
    },
    {
        COUNTRY: 'AD',
        ZONE: 'ADxx',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE01',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE02',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE03',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE06',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE10',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE11',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE12',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE13',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE14',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE15',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE16',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE17',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE18',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE19',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE20',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE21',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE22',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE23',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE24',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE25',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE26',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE28',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE29',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE30',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE31',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE32',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE33',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE34',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE35',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE36',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE37',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE38',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE39',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE40',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE41',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE42',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE43',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE44',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE45',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE46',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE47',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE48',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE49',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE50',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE51',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE53',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE55',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE56',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE59',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE60',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE61',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE62',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE64',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE65',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE66',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE67',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE68',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE69',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE70',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE71',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE72',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE73',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE75',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE76',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE77',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE78',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE79',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE80',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE81',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE82',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE83',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE84',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE85',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE86',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE87',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE88',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE89',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE90',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE91',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE92',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE93',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE94',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE95',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE96',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE97',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE98',
    },
    {
        COUNTRY: 'BE',
        ZONE: 'BE99',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG10',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG11',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG12',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG13',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG14',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG15',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG16',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG17',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG18',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG19',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG20',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG21',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG22',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG23',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG24',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG25',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG26',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG27',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG28',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG29',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG30',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG31',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG32',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG33',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG34',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG35',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG36',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG37',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG38',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG39',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG40',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG41',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG42',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG43',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG44',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG45',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG46',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG47',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG48',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG49',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG50',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG51',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG52',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG53',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG54',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG55',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG56',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG57',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG58',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG59',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG60',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG61',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG62',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG63',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG64',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG65',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG66',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG67',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG68',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG69',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG70',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG71',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG72',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG73',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG74',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG75',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG76',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG77',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG78',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG79',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG80',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG81',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG82',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG83',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG84',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG85',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG86',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG87',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG88',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG89',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG90',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG91',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG92',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG93',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG94',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG95',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG96',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG97',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG98',
    },
    {
        COUNTRY: 'BG',
        ZONE: 'BG99',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA70',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA71',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA72',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA73',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA74',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA75',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA76',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA77',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA78',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA79',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA80',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA88',
    },
    {
        COUNTRY: 'BA',
        ZONE: 'BA89',
    },
    {
        COUNTRY: 'BY',
        ZONE: 'BYxx',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH10',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH11',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH12',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH13',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH14',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH15',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH16',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH17',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH18',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH19',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH20',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH21',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH22',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH23',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH24',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH25',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH26',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH27',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH28',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH29',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH30',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH31',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH32',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH33',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH34',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH35',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH36',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH37',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH38',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH39',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH40',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH41',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH42',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH43',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH44',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH45',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH46',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH47',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH48',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH49',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH50',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH51',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH52',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH53',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH54',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH55',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH56',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH57',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH60',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH61',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH62',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH63',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH64',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH65',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH66',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH67',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH68',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH69',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH70',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH71',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH72',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH73',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH74',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH75',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH76',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH77',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH78',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH80',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH81',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH82',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH83',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH84',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH85',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH86',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH87',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH88',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH89',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH90',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH91',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH92',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH93',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH94',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH95',
    },
    {
        COUNTRY: 'CH',
        ZONE: 'CH96',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ10',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ11',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ12',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ13',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ14',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ15',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ16',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ17',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ18',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ19',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ25',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ26',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ27',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ28',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ29',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ30',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ31',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ32',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ33',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ34',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ35',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ36',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ37',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ38',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ39',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ40',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ41',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ43',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ44',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ46',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ47',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ50',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ51',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ53',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ54',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ55',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ56',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ57',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ58',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ59',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ60',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ61',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ62',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ63',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ64',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ66',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ67',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ68',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ69',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ70',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ71',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ72',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ73',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ74',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ75',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ76',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ77',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ78',
    },
    {
        COUNTRY: 'CZ',
        ZONE: 'CZ79',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE01',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE02',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE03',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE04',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE06',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE07',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE08',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE09',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE10',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE11',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE12',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE13',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE14',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE15',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE16',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE17',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE18',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE19',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE20',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE21',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE22',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE23',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE24',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE25',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE26',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE27',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE28',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE29',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE30',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE31',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE32',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE33',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE34',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE35',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE36',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE37',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE38',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE39',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE40',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE41',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE42',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE44',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE45',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE46',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE47',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE48',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE49',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE50',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE51',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE52',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE53',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE54',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE55',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE56',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE57',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE58',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE59',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE60',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE61',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE63',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE64',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE65',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE66',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE67',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE68',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE69',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE70',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE71',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE72',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE73',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE74',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE75',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE76',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE77',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE78',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE79',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE80',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE81',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE82',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE83',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE84',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE85',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE86',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE87',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE88',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE89',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE90',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE91',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE92',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE93',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE94',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE95',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE96',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE97',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE98',
    },
    {
        COUNTRY: 'DE',
        ZONE: 'DE99',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK08',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK09',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK10',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK11',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK12',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK13',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK14',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK15',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK16',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK17',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK18',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK19',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK20',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK21',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK22',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK23',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK24',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK25',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK26',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK27',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK28',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK29',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK30',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK31',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK32',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK33',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK34',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK35',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK36',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK37',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK38',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK39',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK40',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK41',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK42',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK43',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK44',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK45',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK46',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK47',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK48',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK49',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK50',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK51',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK52',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK53',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK54',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK55',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK56',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK57',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK58',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK59',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK60',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK61',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK62',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK63',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK64',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK65',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK66',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK67',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK68',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK69',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK70',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK71',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK72',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK73',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK74',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK75',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK76',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK77',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK78',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK79',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK80',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK81',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK82',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK83',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK84',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK85',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK86',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK87',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK88',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK89',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK90',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK91',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK92',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK93',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK94',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK95',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK96',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK97',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK98',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK99',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES01',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES02',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES03',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES04',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES05',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES06',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES07',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES08',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES09',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES10',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES11',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES12',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES13',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES14',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES15',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES16',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES17',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES18',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES19',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES20',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES21',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES22',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES23',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES24',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES25',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES26',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES27',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES28',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES29',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES30',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES31',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES32',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES33',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES34',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES35',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES36',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES37',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES38',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES39',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES40',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES41',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES42',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES43',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES44',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES45',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES46',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES47',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES48',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES49',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES50',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES51',
    },
    {
        COUNTRY: 'ES',
        ZONE: 'ES52',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE10',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE11',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE12',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE13',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE15',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK19',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE20',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE21',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE29',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE30',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK31',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE40',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE41',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE42',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE43',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE44',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE45',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE46',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE48',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE49',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE50',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE51',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE60',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE61',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE62',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE63',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE64',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE65',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE66',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE67',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE68',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE69',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE70',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE71',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE72',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE73',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE74',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE75',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE76',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE78',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE79',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE80',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK85',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE86',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE87',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE88',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE90',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE91',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE92',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE93',
    },
    {
        COUNTRY: 'EE',
        ZONE: 'EE94',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR01',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR02',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR03',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR04',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR05',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR06',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR07',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR08',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR09',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR10',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR11',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR12',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR13',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR14',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR15',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR16',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR17',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR18',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR19',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR20',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR21',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR22',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR23',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR24',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR25',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR26',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR27',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR28',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR29',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR30',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR31',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR32',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR33',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR34',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR35',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR36',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR37',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR38',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR39',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR40',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR41',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR42',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR43',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR44',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR45',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR46',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR47',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR48',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR49',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR50',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR51',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR52',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR53',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR54',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR55',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR56',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR57',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR58',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR59',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR60',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR61',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR62',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR63',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR64',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR65',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR66',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR67',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR68',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR69',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR70',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR71',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR72',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR73',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR74',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR75',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR76',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR77',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR78',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR79',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR80',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR81',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR82',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR83',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR84',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR85',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR86',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR87',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR88',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR89',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR90',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR91',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR92',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR93',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR94',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR95',
    },
    {
        COUNTRY: 'FR',
        ZONE: 'FR97',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI00',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI01',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI02',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI03',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI04',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI05',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI06',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI07',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI08',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI09',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI10',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI11',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI12',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI13',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI14',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI15',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI16',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI17',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI18',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI19',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI20',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI21',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI22',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI23',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI24',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI25',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI26',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI27',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI28',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI29',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI30',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI31',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI32',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI33',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI34',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI35',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI36',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI37',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI38',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI39',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI40',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI41',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI42',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI43',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI44',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI45',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI46',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI47',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI48',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI49',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI50',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI51',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI52',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI53',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI54',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI55',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI56',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI57',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI58',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI59',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI60',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI61',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI62',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI63',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI64',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI65',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI66',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI67',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI68',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI69',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI70',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI71',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI72',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI73',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI74',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI75',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI76',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI77',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI78',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI79',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI80',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI81',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI82',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI83',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI84',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI85',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI86',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI87',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI88',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI89',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI90',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI91',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI92',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI93',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI94',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI95',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI96',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI97',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI98',
    },
    {
        COUNTRY: 'FI',
        ZONE: 'FI99',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBAB',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBAL',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBB',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBBA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBBB',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBBD',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBBH',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBBL',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBBN',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBBR',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBBS',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBBT',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCB',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCF',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCH',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCM',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCO',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCR',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCT',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCV',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBCW',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBDA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBDD',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBDE',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBDG',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBDH',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBDL',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBDN',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBDT',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBDY',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBE',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBEC',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBEH',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBEN',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBEX',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBFK',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBFY',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBG',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBGL',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBGU',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBHA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBHD',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBHG',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBHP',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBHR',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBHS',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBHU',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBHX',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBIG',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBIM',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBIP',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBIV',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBJE',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBKA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBKT',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBKW',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBKY',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBL',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBLA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBLD',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBLE',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBLL',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBLN',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBLS',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBLU',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBM',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBME',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBMK',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBML',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBN',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBNE',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBNG',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBNN',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBNP',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBNR',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBNW',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBOL',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBOX',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBPA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBPE',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBPH',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBPL',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBPO',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBPR',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBRG',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBRH',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBRM',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBS',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSE',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSG',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSK',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSL',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSM',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSN',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSO',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSP',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSR',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSS',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBST',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSW',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBSY',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBTA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBTD',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBTF',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBTN',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBTQ',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBTR',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBTS',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBTW',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBUB',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBW',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBWA',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBWC',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBWD',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBWF',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBWN',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBWR',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBWS',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBWV',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBYO',
    },
    {
        COUNTRY: 'GB',
        ZONE: 'GBZE',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR10',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR11',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR12',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR13',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR14',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR15',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR16',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR17',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR18',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR19',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR20',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR21',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR22',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR23',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR24',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR25',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR26',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR27',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR28',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR29',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR30',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR31',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR32',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR33',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR34',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR35',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR36',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR37',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR38',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR40',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR41',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR42',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR43',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR44',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR45',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR46',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR47',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR48',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR49',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR50',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR51',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR52',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR53',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR54',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR55',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR56',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR57',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR58',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR59',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR60',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR61',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR62',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR63',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR64',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR65',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR66',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR67',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR68',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR69',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR70',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR71',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR72',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR73',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR74',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR80',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR81',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR82',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR83',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR84',
    },
    {
        COUNTRY: 'GR',
        ZONE: 'GR85',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU10',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU11',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU12',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU15',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU16',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU20',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU21',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU22',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU23',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU24',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU25',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU26',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU27',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU28',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU29',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU30',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU31',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU32',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU33',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU34',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU35',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU36',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU37',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU38',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU39',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU40',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU41',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU42',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU43',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU44',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU45',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU46',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU47',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU48',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU49',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU50',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU51',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU52',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU53',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU54',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU55',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU56',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU57',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU58',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU59',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU60',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU61',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU62',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU63',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU64',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU65',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU66',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU67',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU68',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU69',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU70',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU71',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU72',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU73',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU74',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU75',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU76',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU77',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU78',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU79',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU80',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU81',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU82',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU83',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU84',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU85',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU86',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU87',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU88',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU89',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU90',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU91',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU92',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU93',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU94',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU95',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU96',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU97',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU98',
    },
    {
        COUNTRY: 'HU',
        ZONE: 'HU99',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR00',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR01',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR02',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR10',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR11',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR20',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR21',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR22',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR23',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR31',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR32',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR33',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR34',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR35',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR37',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR40',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR41',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR42',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR43',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR44',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR47',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR48',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR49',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR51',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR52',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR53',
    },
    {
        COUNTRY: 'HR',
        ZONE: 'HR95',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT00',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT01',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT02',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT03',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT04',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT05',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT06',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT07',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT08',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT09',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT10',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT11',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT12',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT13',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT14',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT15',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT16',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT17',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT18',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT19',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT20',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT21',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT22',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT23',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT24',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT25',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT26',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT27',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT28',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT29',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT30',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT31',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT32',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT33',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT34',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT35',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT36',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT37',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT38',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT39',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT40',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT41',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT42',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT43',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT44',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT45',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT46',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT47',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT48',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT50',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT51',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT52',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT53',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT54',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT55',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT56',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT57',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT58',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT59',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT60',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT61',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT62',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT63',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT64',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT65',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT66',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT67',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT70',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT71',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT72',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT73',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT74',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT75',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT76',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT80',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT81',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT82',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT83',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT84',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT85',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT86',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT87',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT88',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT89',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT90',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT91',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT92',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT93',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT94',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT95',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT96',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT97',
    },
    {
        COUNTRY: 'IT',
        ZONE: 'IT98',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IECE',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IECK',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IECN',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IECW',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEDL',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEDN',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEGY',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEKE',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEKK',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEKY',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IELD',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IELH',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IELK',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IELM',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IELS',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEMH',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEMN',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEMO',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEOY',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IERN',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IESO',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IETY',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEWD',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEWH',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEWW',
    },
    {
        COUNTRY: 'IE',
        ZONE: 'IEWX',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU10',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU11',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU12',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU13',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU14',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU15',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU16',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU17',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU18',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU19',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU20',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU21',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU22',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU23',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU24',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU25',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU26',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU27',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU28',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU29',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU30',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU32',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU33',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU34',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU35',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU36',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU37',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU38',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU39',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU40',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU41',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU42',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU43',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU44',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU45',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU46',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU47',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU48',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU49',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU50',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU52',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU53',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU54',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU55',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU56',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU57',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU58',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU59',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU61',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU62',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU63',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU64',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU65',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU66',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU67',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU68',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU69',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU72',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU73',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU74',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU75',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU76',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU77',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU80',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU81',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU82',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU83',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU84',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU85',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU86',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU87',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU88',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU90',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU91',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU92',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU93',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU94',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU95',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU96',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU97',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU98',
    },
    {
        COUNTRY: 'LU',
        ZONE: 'LU99',
    },
    {
        COUNTRY: 'LI',
        ZONE: 'LIxx',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT00',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT01',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT02',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT03',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT04',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT05',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT06',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT07',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT08',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT09',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT10',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT11',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT12',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT13',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT14',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT15',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT16',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT17',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT18',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT19',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT20',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT21',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT22',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT23',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT24',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT25',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT26',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT27',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT28',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT29',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT30',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT31',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT32',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT33',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT34',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT35',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT36',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT37',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT38',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT39',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT40',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT41',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT42',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT43',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT44',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT45',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT46',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT47',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT48',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT49',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT50',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT51',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT52',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT53',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT54',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT55',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT56',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT57',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT58',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT59',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT60',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT61',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT62',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT63',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT64',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT65',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT66',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT67',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT68',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT69',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT70',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT71',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT72',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT73',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT74',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT75',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT76',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT77',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT78',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT79',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT80',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT81',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT82',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT83',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT84',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT85',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT86',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT87',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT88',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT89',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT90',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT91',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT92',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT93',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT94',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT95',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT96',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT97',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT98',
    },
    {
        COUNTRY: 'LT',
        ZONE: 'LT99',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV10',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV20',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV21',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV30',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV31',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV32',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV33',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV34',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV36',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV37',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV38',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV39',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV40',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV41',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV42',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV43',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV44',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV45',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV46',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV47',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV48',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV50',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV51',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV52',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV53',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV54',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV56',
    },
    {
        COUNTRY: 'LV',
        ZONE: 'LV57',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD20',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD30',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD31',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD32',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD33',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD34',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD35',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD36',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD37',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD38',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD39',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD40',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD41',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD42',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD43',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD44',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD45',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD46',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD47',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD48',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD49',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD50',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD51',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD52',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD53',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD54',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD55',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD56',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD57',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD58',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD59',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD61',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD62',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD63',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD64',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD65',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD66',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD67',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD68',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD71',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD72',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD73',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD74',
    },
    {
        COUNTRY: 'MD',
        ZONE: 'MD77',
    },
    {
        COUNTRY: 'ME',
        ZONE: 'ME81',
    },
    {
        COUNTRY: 'ME',
        ZONE: 'ME84',
    },
    {
        COUNTRY: 'ME',
        ZONE: 'ME85',
    },
    {
        COUNTRY: 'ME',
        ZONE: 'ME86',
    },
    {
        COUNTRY: 'MK',
        ZONE: 'MK10',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK12',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK13',
    },
    {
        COUNTRY: 'MK',
        ZONE: 'MK14',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK20',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK22',
    },
    {
        COUNTRY: 'MK',
        ZONE: 'MK23',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK24',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK60',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK62',
    },
    {
        COUNTRY: 'MK',
        ZONE: 'MK63',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK65',
    },
    {
        COUNTRY: 'MK',
        ZONE: 'MK70',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK72',
    },
    {
        COUNTRY: 'DK',
        ZONE: 'DK73',
    },
    {
        COUNTRY: 'MK',
        ZONE: 'MK75',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO00',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO01',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO02',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO03',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO04',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO05',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO06',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO07',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO08',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO09',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO10',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO11',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO12',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO13',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO14',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO15',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO16',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO17',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO18',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO19',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO20',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO21',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO22',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO23',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO24',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO25',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO26',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO27',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO28',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO29',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO30',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO31',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO32',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO33',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO34',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO35',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO36',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO37',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO38',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO39',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO40',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO41',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO42',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO43',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO44',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO45',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO46',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO47',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO48',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO49',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO50',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO51',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO52',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO53',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO54',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO55',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO56',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO57',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO58',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO59',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO60',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO61',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO62',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO63',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO64',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO65',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO66',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO67',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO68',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO69',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO70',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO71',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO72',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO73',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO74',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO75',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO76',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO77',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO78',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO79',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO80',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO81',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO82',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO83',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO84',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO85',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO86',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO87',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO88',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO89',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO90',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO91',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO92',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO93',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO94',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO95',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO96',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO97',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO98',
    },
    {
        COUNTRY: 'NO',
        ZONE: 'NO99',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL10',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL11',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL12',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL13',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL14',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL15',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL16',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL17',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL18',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL19',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL20',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL21',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL22',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL23',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL24',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL25',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL26',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL27',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL28',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL29',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL30',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL31',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL32',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL33',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL34',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL35',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL36',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL37',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL38',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL39',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL40',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL41',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL42',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL43',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL44',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL45',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL46',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL47',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL48',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL49',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL50',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL51',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL52',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL53',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL54',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL55',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL56',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL57',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL58',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL59',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL60',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL61',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL62',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL63',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL64',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL65',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL66',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL67',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL68',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL69',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL70',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL71',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL72',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL73',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL74',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL75',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL76',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL77',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL78',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL79',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL80',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL81',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL82',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL83',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL84',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL85',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL86',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL87',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL88',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL89',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL90',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL91',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL92',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL93',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL94',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL95',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL96',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL97',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL98',
    },
    {
        COUNTRY: 'NL',
        ZONE: 'NL99',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT10',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT11',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT12',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT13',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT14',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT15',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT16',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT17',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT18',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT19',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT20',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT21',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT22',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT23',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT24',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT25',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT26',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT27',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT28',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT29',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT30',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT31',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT32',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT33',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT34',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT35',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT36',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT37',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT38',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT40',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT41',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT42',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT43',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT44',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT45',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT46',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT47',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT48',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT49',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT50',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT51',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT52',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT53',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT54',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT60',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT61',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT62',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT63',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT64',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT70',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT71',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT72',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT73',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT74',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT75',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT76',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT77',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT78',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT79',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT80',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT81',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT82',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT83',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT84',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT85',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT86',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT87',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT88',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT89',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT90',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT91',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT92',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT93',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT94',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT95',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT96',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT97',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT98',
    },
    {
        COUNTRY: 'PT',
        ZONE: 'PT99',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL00',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL01',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL02',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL03',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL04',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL05',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL06',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL07',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL08',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL09',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL10',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL11',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL12',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL13',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL14',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL15',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL16',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL17',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL18',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL19',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL20',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL21',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL22',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL23',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL24',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL25',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL26',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL27',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL28',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL29',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL30',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL31',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL32',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL33',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL34',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL35',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL36',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL37',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL38',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL39',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL40',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL41',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL42',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL43',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL44',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL45',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL46',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL47',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL48',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL49',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL50',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL51',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL52',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL53',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL54',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL55',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL56',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL57',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL58',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL59',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL60',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL61',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL62',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL63',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL64',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL65',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL66',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL67',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL68',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL69',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL70',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL71',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL72',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL73',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL74',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL75',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL76',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL77',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL78',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL79',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL80',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL81',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL82',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL83',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL84',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL85',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL86',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL87',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL88',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL89',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL90',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL91',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL92',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL93',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL94',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL95',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL96',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL97',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL98',
    },
    {
        COUNTRY: 'PL',
        ZONE: 'PL99',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO00',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO01',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO02',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO03',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO04',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO05',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO06',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO07',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO08',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO09',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO10',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO11',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO12',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO13',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO14',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO15',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO16',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO17',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO18',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO19',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO20',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO21',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO22',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO23',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO24',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO25',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO26',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO27',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO28',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO29',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO30',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO31',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO32',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO33',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO34',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO35',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO36',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO37',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO38',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO39',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO40',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO41',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO42',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO43',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO44',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO45',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO46',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO47',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO48',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO49',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO50',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO51',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO52',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO53',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO54',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO55',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO56',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO57',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO58',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO59',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO60',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO61',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO62',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO63',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO64',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO65',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO66',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO67',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO68',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO69',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO70',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO71',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO72',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO73',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO75',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO80',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO81',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO82',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO83',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO84',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO85',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO86',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO87',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO88',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO90',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO91',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO92',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO94',
    },
    {
        COUNTRY: 'RO',
        ZONE: 'RO97',
    },
    {
        COUNTRY: 'SM',
        ZONE: 'SMxx',
    },
    {
        COUNTRY: 'RU',
        ZONE: 'RUxx',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE10',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE11',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE12',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE13',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE14',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE15',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE16',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE17',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE18',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE19',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE20',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE21',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE22',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE23',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE24',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE25',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE26',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE27',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE28',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE29',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE30',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE31',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE33',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE34',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE35',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE36',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE37',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE38',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE39',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE40',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE41',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE42',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE43',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE44',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE45',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE46',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE47',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE50',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE51',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE52',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE53',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE54',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE55',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE56',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE57',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE58',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE59',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE60',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE61',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE62',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE63',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE64',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE65',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE66',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE67',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE68',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE69',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE70',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE71',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE72',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE73',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE74',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE75',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE76',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE77',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE78',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE79',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE80',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE81',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE82',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE83',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE84',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE85',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE86',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE87',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE88',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE89',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE90',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE91',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE92',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE93',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE94',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE95',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE96',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE97',
    },
    {
        COUNTRY: 'SE',
        ZONE: 'SE98',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS10',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS11',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS12',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS13',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS14',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS15',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS16',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS17',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS18',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS19',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS20',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS21',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS22',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS23',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS24',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS25',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS26',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS30',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS31',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS32',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS33',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS34',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS35',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS36',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS37',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS38',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS40',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS43',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS46',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS49',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS50',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS51',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS52',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS53',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS56',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS57',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS60',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS71',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS72',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS73',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS74',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS76',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS78',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS81',
    },
    {
        COUNTRY: 'RS',
        ZONE: 'RS98',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK01',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK02',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK03',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK04',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK05',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK06',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK07',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK08',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK09',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK25',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK28',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK35',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK36',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK44',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK51',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK62',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK78',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK79',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK80',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK81',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK82',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK83',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK84',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK85',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK90',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK91',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK92',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK93',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK94',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK95',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK96',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK97',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK98',
    },
    {
        COUNTRY: 'SK',
        ZONE: 'SK99',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI10',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI11',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI12',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI13',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI14',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI15',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI16',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI17',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI18',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI19',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI20',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI21',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI22',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI23',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI24',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI25',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI26',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI27',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI28',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI29',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI30',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI31',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI32',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI33',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI34',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI35',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI36',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI37',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI38',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI39',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI40',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI41',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI42',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI43',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI44',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI45',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI46',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI47',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI48',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI49',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI50',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI51',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI52',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI53',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI54',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI55',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI56',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI57',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI58',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI59',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI60',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI61',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI62',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI63',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI64',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI65',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI66',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI67',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI68',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI69',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI80',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI81',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI82',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI83',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI84',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI85',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI86',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI87',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI88',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI89',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI90',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI91',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI92',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI93',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI94',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI95',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI96',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI97',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI98',
    },
    {
        COUNTRY: 'SI',
        ZONE: 'SI99',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR01',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR02',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR03',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR04',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR05',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR06',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR07',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR08',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR09',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR10',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR11',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR12',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR13',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR14',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR15',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR16',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR17',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR18',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR19',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR20',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR21',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR22',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR23',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR24',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR25',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR26',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR27',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR28',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR29',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR30',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR31',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR32',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR33',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR34',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR35',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR36',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR37',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR38',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR39',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR40',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR41',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR42',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR43',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR44',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR45',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR46',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR47',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR48',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR49',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR50',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR51',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR52',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR53',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR54',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR55',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR56',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR57',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR58',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR59',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR60',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR61',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR62',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR63',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR64',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR65',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR66',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR67',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR68',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR69',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR70',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR71',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR72',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR73',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR74',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR75',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR76',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR77',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR78',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR79',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR80',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR81',
    },
    {
        COUNTRY: 'TR',
        ZONE: 'TR99',
    },
    {
        COUNTRY: 'UA',
        ZONE: 'UAxx',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ10',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ11',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ12',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ13',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ14',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ15',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ20',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ21',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ22',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ23',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ24',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ30',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ31',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ32',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ40',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ41',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ42',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ43',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ50',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ51',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ60',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ61',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ62',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ70',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ71',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ72',
    },
    {
        COUNTRY: 'XZ',
        ZONE: 'XZ73',
    },
];
